<div #mapboxDirections id="mapbox-directions"></div>
